import { environment } from "./environments/environment";

export class Konfiguracja {
    AdresApi: string;

    constructor() {
        this.AdresApi = environment.apiURL;
    }
}